<app-new-header></app-new-header>
<!-- <div class="hero">
  <div class="overlay">
    <div class="container">
      <div class="content">
        <div class="meta">
          <img loading="lazy" src="../../../assets/images/new/rate.png" />
          <img loading="lazy" src="../../../assets/images/new/stars.png" />
          <span> 4.8 out of 5 </span>
        </div>
        <h1>Increase ratings and SERP ranking with real organic feedback customers</h1>
        <div class="desc">Take advantage of the best local ranking solution to rank your site higher on Google, thanks to our residential network.</div>
        <a href="https://wa.me/message/YMIRQRC2ZXZNO1" target="_blank" class="my-button blue"> Contact us</a>
      </div>
      <div class="images">
        <div class="text">Rankings increase tested and proven for all businesses</div>
        <div class="cards">
          <div class="cards__item">
            <img loading="lazy" src="../../../assets/images/new/google.svg" alt="" />
          </div>
          <div class="cards__item center">
            <img loading="lazy" src="../../../assets/images/new/kiss.svg" alt="" />
          </div>
          <div class="cards__item">
            <img loading="lazy" src="../../../assets/images/new/google_analys.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<section *ngIf="!isFusionStore" class="main_rate">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="rate_inner text-center">
          <p>
            <span> <img loading="lazy" src="../../../assets/images/new/rate.png" /></span>
            <span><img loading="lazy" src="../../../assets/images/new/stars.png" /> </span>
            <span> <b> 4.8 out of 5 </b> </span>
          </p>
          <h1 class="mt-5 heading-6">Accelerate Sales and Build a Thriving Community
            </h1>
          <div class="title__wrap">
            <p class="hero-sub-title white-color">Enhance your business by combining powerful sales techniques with community engagement. Drive growth through increased conversions while fostering a loyal and connected customer base that supports your brand's long-term success.</p>
          </div>
          <div class="w-100 text-center download_btns">
            <!-- <a href="" class=""> Try for 3 days <small> it's free</small></a> -->
            <a href="https://wa.me/message/YMIRQRC2ZXZNO1" target="_blank" class="btn see-features"> Contact us</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 bottom_logo">
      <div class="row">
        <div class="col-md-3">
          <p>Rankings increase tested and proven for all businesses</p>
        </div>
        <div class="col-3">
          <img loading="lazy" src="../../../assets/images/new/google.svg" alt="" />
        </div>
        <div class="col-3">
          <img loading="lazy" src="../../../assets/images/new/kiss.svg" alt="" />
        </div>

        <div class="col-3">
          <img loading="lazy" src="../../../assets/images/new/google_analys.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section *ngIf="!isFusionStore" class="Increase_seo" id="Increase_seo">
  <div class="container">
    <div class="row">
      <div class="col-md-5">
        <h1>Increase local SEO with review strategy</h1>
        <p>Improve your SEO ranking positions by increasing the quantity and quality of your reviews. Increase it organically with real feedback from your customers with targeted keywords to increase native rank.</p>
      </div>
      <div class="col-md-6 offset-md-1">
        <img src="https://uploads-ssl.webflow.com/62fc99884495577f1afa61fe/62fc99884495575e76fa633e_GIF%20SEARCHSEO.gif" loading="lazy" alt="organic ctr bot searchseo" class="image-gif-ctr" />
      </div>
    </div>
  </div>
</section> -->

<!-- <section *ngIf="!isFusionStore" class="automated">
  <div class="container">
    <div class="row">
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Automated.png" alt="" />
          </div>
          <div class="automated_content">
            <h3>Automated Review generator</h3>
            <p>Take advantage of our traffic generator network that works like an organic traffic bot. All the traffic sent is unique and natural.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Increase.png" alt="" />
          </div>
          <div class="automated_content">
            <h3>Increase CTR</h3>
            <p>Organic Click-through-rate is one of the most important SEO ranking factor. Clicks are displayed in the Google Search Console only with Kachiing' traffic generator.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Local.svg" alt="" />
          </div>
          <div class="automated_content">
            <h3>Local SEO Ranking</h3>
            <p>Drive real searches from the country where you operate your business. Improve your local rankings thanks to SEO traffic bot.<span class="text-span-3">+ countries available.</span></p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Campaign.svg" alt="" />
          </div>
          <div class="automated_content">
            <h3>Keyword Targeting</h3>
            <p>Target specific keywords in your reviews for rank particularly for them. With Kachiing we help you analyze and target.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Settings.svg" alt="" />
          </div>
          <div class="automated_content">
            <h3>Smart Settings</h3>
            <p>More than 10 features are available to optimize your auto traffic bot project according to your needs. Your project is ready to launch within 3 minutes.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <div class="automat_in">
          <div class="automat_icon">
            <img loading="lazy" src="../../../assets/images/new/Increase.png" alt="" />
          </div>
          <div class="automated_content">
            <h3>Increase traffic flow</h3>
            <p>Time on site is an important ranking factor that shows to Google commitment and user signals. Organic traffic generator can manipulate this metric.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="!isFusionStore" class="locations">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="loc_bg">
          <div class="col-md-4">
            <div class="locaton">
              <h2>50+ Locations</h2>
              <p>Kachiing's network features are the most advanced effective way to improve your Local SEO rankings.</p>
              <p>If you are in the US market, Kachiing will only bring real US visits / Reviews / Feedback that improves your SEO on Google.com.</p>
              <p>Example: If you target the French market, Kachiing will only bring real visits / Reviews / Feedback and clicks from France (The network searches your keywords on Google.fr)</p>
              <a href="">countries (50+) 🌎</a>
            </div>
          </div>
          <div class="col-md-7 offset-md-1">
            <div class="row1">
              <div class="grid-4">
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/India.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>India IPs</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>French IPs</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United1.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United1.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United3.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United4.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United5.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United6.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>United states IP</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/Mexico.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>Mexico IPs</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/United.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>Spain IPs</p>
                  </div>
                </div>
                <div class="loc_in">
                  <div class="loc_icon">
                    <img loading="lazy" src="../../../assets/images/new/Turkey.svg" alt="" />
                  </div>
                  <div class="loc_content">
                    <h6>8,404,321</h6>
                    <p>Turkey IPs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="!isFusionStore" class="pricing" id="scroll_pricing">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="price-title text-center text-white">
          <h2 class="">Pricing plan</h2>
          <p>You can hold several plans on the same account. All subscriptions are without commitment</p>
        </div>
      </div>

      <div class="col-md-12">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="price-menu text-white text-center">
              <div class="row justify-content-center">
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>BIZ</h3>
                    <ul>
                      <li>1 URL included</li>
                      <li>1 Business</li>
                      <li>Free Consultancy</li>
                    </ul>
                    <div class="price-value">
                      <h2>$149/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>ENTERPRISE</h3>
                    <ul>
                      <li>2 URLs included</li>
                      <li>Multi-Business</li>
                      <li>Dedicated Consultancy</li>
                    </ul>
                    <div class="price-value">
                      <h2>$219/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>CUSTOM</h3>
                    <ul>
                      <li>X URLs included</li>
                      <li>Multiple Business</li>
                      <li>Dedicated Consultancy</li>
                    </ul>
                    <div class="price-value">
                      <h2>$Check/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="price-menu text-white text-center">
              <div class="row">
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>Mini</h3>
                    <ul>
                      <li>25 clicks per day</li>
                      <li>12 keywords included</li>
                      <li>2 pages visited</li>
                      <li>Up to 1min session duration</li>
                    </ul>
                    <div class="price-value">
                      <h2>$29/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>Medium</h3>
                    <ul>
                      <li>50 clicks per day</li>
                      <li>25 keywords included</li>
                      <li>2 pages visited</li>
                      <li>Up to 2min session duration</li>
                    </ul>
                    <div class="price-value">
                      <h2>$49/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list" style="">
                    <h3>Large</h3>
                    <ul>
                      <li>100 clicks per day</li>
                      <li>50 keywords included</li>
                      <li>2 pages visited</li>
                      <li>Up to 3min session duration</li>
                    </ul>
                    <div class="price-value">
                      <h2>$89/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 px-2 my-1">
                  <div class="price-list">
                    <h3>Ultimate</h3>
                    <ul>
                      <li>150 clicks per day</li>
                      <li>75 keywords included</li>
                      <li>3 pages visited</li>
                      <li>Up to 4min session duration</li>
                    </ul>
                    <div class="price-value">
                      <h2>$129/mo</h2>
                      <a href="#" class="d-flex justify-content-center align-items-center">Get started</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="!isFusionStore" class="faq" id="faq">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 style="margin-left: auto; margin-right: auto; width: 50%; font-weight: 500; text-decoration: underline; text-align: center">WHY Kachiing?</h1>
        <div class="demo">
          <div class="accordion" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseOne">Is Kachiing a better alternative to buying reviews to increase the local rank? <i class="fa fa-plus"></i></button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                  <p>Kachiing's automated feedback system allows you to get genuine feedback for your business which you can filter before allowing them to post to your online social accounts such as Google, Facebook, Trustpilot, Trip Advisor etc.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseTwo">Buy reviews: Should You Really Do It? This Will Help You Decide! <i class="fa fa-plus"></i></button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                  <p>Yes and No. In fact Kachiing helps successful businesses do both at the same time. Organic growth is require for the long term while in the immediate we help boost reviews to a base number.</p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree">What features make Kachiing become the best review generation software? <i class="fa fa-plus"></i></button>
                </h2>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                <div class="card-body">
                  <p>Kachiing's easily customizable features allow a user to leverage his strengths to get the feedback or reviews he requires. Full customization with a dedicated consultancy is provided for enterprise businesses which have multiple entities under them.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h1 style="margin-left: auto; margin-right: auto; width: 50%; font-weight: 500; text-decoration: underline; text-align: center">USE CASES</h1>
        <div class="demo">
          <div class="accordion" id="accordionExample2">
            <div class="card">
              <div class="card-header" id="headingFour">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseFour">How does Kachiing help improve my visibility to Tourists? <i class="fa fa-plus"></i></button>
                </h2>
              </div>
              <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample2">
                <div class="card-body card-img">
                  <img loading="lazy" src="../../../assets/images/new/Automated_Review_generator.jpeg" alt="" />
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingFive">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseFive">What type of business does Kachiing benefit the most? <i class="fa fa-plus"></i></button>
                </h2>
              </div>
              <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample2">
                <div class="card-body card-img">
                  <img loading="lazy" src="../../../assets/images/new/marketing.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="!isFusionStore" class="usecase" id="usecase" style="padding: 0">
  <app-new-use-case></app-new-use-case>
</section> -->